export const hidePhone = (phone: string): string => {
  return phone.replace(/(\d{3})\d{3}(\d*$)/g, "$1***$2");
};

export const splitByComman = (input: string[] | number[]): string => {
  return input.join("、");
};

export const numberWithComma = (num = 0): string =>
  Math.floor(num)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const truncateNumber = (num: number): string => {
  const number = Math.round(num);
  const thousand = 1000;
  const million = 1000000;
  const billion = 100000000;

  if (number < 100000) return `${numberWithComma(number)}`;

  if (number < million) return `${Math.round((number / thousand) * 10) / 10}K`;
  else if (number >= million && number < billion)
    return `${Math.round((number / million) * 10) / 10}M`;
  else return `${Math.round((number / billion) * 10) / 10}B`;
};
